<template lang="pug">
  .shipping-step
    validation-provider(:rules="{ required: { allowFalse: false } }")
      input.hidden(type="checkbox" :value="!!shipping.id")

    //- .shipping-methods(v-if="methods.length > 1")
    //-   h4.panel-heading Versandart
    .alert.error(v-if="!methods.length")
      p Momentan stehen keine Versandmethoden zur Verfügung.
    template(v-else)
      .shipping-methods
        .panel.mb-8
          .box
            ShippingMethod(
              v-for="(method, i) in methods" :key="method.id"
              :data="method"
              :active="method.id === shipping.id"
              :show-divider="i + 1 < methods.length"
              @select="select"
            )
              template(v-if="methods.length === 1" v-slot:icon)
                .icon
                  svg(
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  )
                    //- d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
                    //- d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                    path(
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.3"
                      d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"
                    )

            //- hr.my-4
            //- // TODO: multiple addresses / add address
            //- AddressForm(type="shipping" label="Lieferadresse" :show-name="true")

      .shipping-addresses
        h4.panel-heading Lieferadresse
        .panel.mb-8
          .box
            Address(
              v-for="(address, i) in addresses" :key="address.id"
              :data="address"
              :active="address.id === shippingAddress.id"
              :show-divider="true"
              :show-label="false"
              @select="setShippingAddress"
            )
            AddressForm(
              label="Lieferadresse"
              type="shipping"
              :show-name="editName"
              :show-label="false"
              :show-checkbox="addresses.length >= 1"
              :active="showAddressForm"
              @select="setShippingAddress"
              @edit="editAddress = true"
            )
</template>

<script>
import uniqid from 'uniqid';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { get, cloneDeep } from '@/helpers';

import ShippingMethod from '@/extensions/shop/components/CheckoutStepper/Steps/Partials/ShippingMethod';
import AddressForm from '@/extensions/shop/components/CheckoutStepper/Steps/Partials/AddressForm';
import Address from '@/extensions/shop/components/CheckoutStepper/Steps/Partials/Address';

export default {
  name: 'ShippingStep',
  props: {
    sections: {
      type: Array,
      required: false
    }
    // form: {
    //   type: Object,
    //   required: true
    // }
  },
  data: () => ({
    editName: true, // TODO: make editable by clicking on pencil icon
    editAddress: false
  }),
  components: {
    ShippingMethod,
    AddressForm,
    Address
  },
  computed: {
    addresses() {
      return this.addressOptions.shipping;
    },
    shippingAddress() {
      return this.checkout.form.account.shipping_address;
    },
    showAddressForm() {
      if (this.isAuthenticated && this.addresses.length) {
        return get(this.shippingAddress, 'id', '').startsWith('new:');
      } else {
        return this.editAddress;
      }
    },
    currency() {
      return (
        get(this.customer, 'customerGroup.currency.iso4217') ||
        get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
        'EUR'
      );
    },
    methods() {
      return this.shippingMethodOptions || [];
    },
    shipping: {
      get() {
        return this.checkout.form.shipping;
      },
      set(value) {
        this.setShipping(value);
      }
    },
    ...mapGetters({
      customer: 'shop/customer',
      isAuthenticated: 'auth/isAuthenticated',
      defaultCustomerGroup: 'shop/defaultCustomerGroup',
      shippingMethodOptions: 'shop/shippingMethodOptions',
      addressOptions: 'shop/addressOptions',
      shippingFee: 'shop/shippingFee',
      checkout: 'shop/checkout'
    })
  },
  methods: {
    select(method) {
      this.shipping = method;
    },
    ...mapMutations({
      setShipping: 'shop/setCheckoutFormShipping',
      setShippingAddress: 'shop/setCheckoutFormShippingAddress'
    }),
    ...mapActions({
      validateCheckout: 'shop/validateCheckoutForm'
    })
  },
  mounted() {
    if (!this.shipping.id && this.methods.length >= 1) {
      this.shipping = this.methods[0];
    }

    // fill address if guest or if not address options
    if (!this.shippingAddress.id) {
      const account = this.checkout.form.account;
      let address = cloneDeep(account.billing_address);
      address.id = uniqid('new:');

      // address.gender = account.gender;
      // address.first_name = account.first_name;
      // address.last_name = account.last_name;
      // address.phone = account.phone;
      // address.mobile = account.mobile;
      // address.email = account.email;

      this.setShippingAddress(address);
      this.validateCheckout();
    }
  }
};
</script>

<style lang="sass" scoped>
.shipping-step
  & > .alert
    margin-top: -2rem
</style>
